import IconOnPrem from '@/assets/icons//iconOnPrem.svg';
import IconApi from '@/assets/icons/iconApi.svg';
import IconData from '@/assets/icons/iconData.svg';
import IconLens from '@/assets/icons/iconLens.svg';
import IconPrint from '@/assets/icons/iconPrint.svg';
import IconPro from '@/assets/icons/iconPro.svg';
import IconTelemarketing from '@/assets/icons/iconTelemarketing.svg';
import IconVectorMap from '@/assets/icons/iconVectorMap.svg';

const navigationLinks = [
  {
    label: 'headerMenuSectionsAllProductsSubcategoriesDatabasesName',
    href: 'headerMenuSectionsAllProductsSubcategoriesDatabasesLink',
    icon: <IconData />,
  },
  {
    label: 'headerMenuSectionsAllProductsSubcategoriesVectorMapsName',
    href: 'headerMenuSectionsAllProductsSubcategoriesVectorMapsLink',
    icon: <IconVectorMap />,
  },
  {
    label: 'headerMenuSectionsAllProductsSubcategories2gisProName',
    href: 'headerMenuSectionsAllProductsSubcategories2gisProLink',
    icon: <IconPro />,
  },
  {
    label: 'headerMenuSectionsAllProductsSubcategoriesApiSdkName',
    href: 'headerMenuSectionsAllProductsSubcategoriesApiSdkLink',
    icon: <IconApi />,
    subLinks: [
      {
        label: 'headerMenuSectionsAllProductsSubcategoriesApiSdkSubRoutingName',
        href: 'headerMenuSectionsAllProductsSubcategoriesApiSdkSubRoutingLink',
        variant: 'small',
      },
      {
        label: 'headerMenuSectionsAllProductsSubcategoriesApiSdkSubCatalogName',
        href: 'headerMenuSectionsAllProductsSubcategoriesApiSdkSubCatalogLink',
        variant: 'small',
      },
      {
        label:
          'headerMenuSectionsAllProductsSubcategoriesApiSdkSubMobileSdkName',
        href: 'headerMenuSectionsAllProductsSubcategoriesApiSdkSubMobileSdkLink',
        variant: 'small',
      },
      {
        label: 'headerMenuSectionsAllProductsSubcategoriesApiSdkSubMapName',
        href: 'headerMenuSectionsAllProductsSubcategoriesApiSdkSubMapLink',
        variant: 'small',
      },
      {
        label: 'headerMenuPlatformManagerName',
        href: '/platform-manager',
        variant: 'small',
      },
    ],
  },
  {
    label: 'headerMenuSectionsAllProductsSubcategoriesTelemarketingName',
    href: 'headerMenuSectionsAllProductsSubcategoriesTelemarketingLink',
    icon: <IconTelemarketing />,
  },
  {
    label: 'headerMenuSectionsAllProductsSubcategoriesOnPremiseName',
    href: 'headerMenuSectionsAllProductsSubcategoriesOnPremiseLink',
    icon: <IconOnPrem />,
  },
  {
    label: 'headerMenuSectionsAllProductsSubcategoriesLensName',
    href: 'headerMenuSectionsAllProductsSubcategoriesLensLink',
    icon: <IconLens />,
  },
  {
    label: 'headerMenuSectionsAllProductsSubcategoriesPrintName',
    href: 'headerMenuSectionsAllProductsSubcategoriesPrintLink',
    icon: <IconPrint />,
  },
];

export default navigationLinks;
